import React, { useState, useEffect, forwardRef } from "react";
import "react-datepicker/dist/react-datepicker.css";

const ContactDetails = (props) => {
  const { contact, setContactShow, EditContact, deleteContact } = props;

  return (
    <div className="card contact-card mb-2">
      <div class="card-header justify-content-between pl-3">
        <h2>Contact Information</h2>
          <div className="text-right">
            <button
              type="button"
              className="btn add-new-contact-btn"
              onClick={() => {
                setContactShow(true);
              }}
            >
              <i class="fas fa-plus-square"></i> Add New Contact
            </button>
          </div>
      </div>
      <div className="card-body">
        <div className="row additional-contact-add-area">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2 d-none">
            <div className="text-right">
              <button
                type="button"
                className="btn add-new-contact-btn"
                onClick={() => {
                  setContactShow(true);
                }}
              >
                <i class="fas fa-plus-square"></i> Add New Contact
              </button>
            </div>
          </div>
          {contact?.map((item, index) => {
            return (
              <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-2 col-sm-12 col-xs-12 mb-2">
                <div className="added-contact">
                  <div className="contact-edit-options">
                    <i
                      className="far fa-edit"
                      title="Edit"
                      onClick={() => {
                        EditContact(item);
                      }}
                    ></i>
                    <i
                      className="far fa-trash-alt red-tooltip"
                      title="Delete"
                      onClick={() => {
                        deleteContact(item);
                      }}
                    ></i>
                  </div>
                  <i className="far fa-user-circle"></i>
                  <h5>{item.name}</h5>
                  <span>{item.email}</span>
                  <p>{item.designation}</p>
                  <p>{item.phone}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ContactDetails;
